import React, { useState, useCallback } from "react";
import { useStore, useSelector } from "react-redux";
import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import MaximizedPanelContainer from "../MaximizedPanelContainer";
import RouteFactorChart from "../RouteFactorChart";
import styles from "./index.module.less";

function RouteFactorChartPanel() {
  const { t } = useTranslation();
  const [type, setType] = useState("thickness");
  const { select } = useStore();
  const passage = useSelector(select.layer.selectCurrentLayer);
  const onChange = useCallback(
    (e) => {
      setType(e.target.value);
    },
    [setType]
  );
  if (!passage || !passage.echart) return null;
  const data = passage.echart.map((item) => {
    return [item.lon, item.lat, item[type]];
  });

  let points = [];
  if (data.length > 0) {
    points = [
      [...data[0], "start"],
      [...data[data.length - 1], "end"],
    ];
  }
  return (
    <div className={`${styles.routeFactorChartPanel} panel-container`}>
      <MaximizedPanelContainer name={t("iceSituation")}>
        <div className="chart-toolbar">
          <Radio.Group
            onChange={onChange}
            defaultValue="thickness"
            buttonStyle="solid"
            size="small"
          >
            <Radio.Button value="thickness">{t("thickness")}</Radio.Button>
            <Radio.Button value="concentration">
              {t("concentration")}
            </Radio.Button>
            <Radio.Button value="rv">{t("risk")}</Radio.Button>
          </Radio.Group>
        </div>
        <div className="chart-container">
          <RouteFactorChart type={type} data={data} points={points} />
        </div>
      </MaximizedPanelContainer>
    </div>
  );
}

export default RouteFactorChartPanel;
